module.exports = __webpack_public_path__ + "img/lex.1b0df63d.jpg";